/* eslint-disable max-len */
import type { IconPrimitiveProps } from 'types';

const IconFreshclub = (props: IconPrimitiveProps) => {
  const {
    size = 24,
    ...rest
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      {...rest}
    >
      <circle cx={12} cy={12} r={11.375} stroke="currentColor" strokeWidth={1.25} />
      <path fill="currentColor" d="M14.864 11.884h-3.033V9.73c0-.287.129-.562.357-.764a1.3 1.3 0 0 1 .86-.317c.465 0 .91-.164 1.238-.456.329-.291.513-.687.513-1.099 0-.412-.184-.808-.513-1.1a1.868 1.868 0 0 0-1.237-.454c-1.251 0-2.45.443-3.335 1.228-.885.786-1.382 1.85-1.384 2.962v2.329c-.285.13-.524.329-.691.572a1.426 1.426 0 0 0-.255.809c0 .285.088.564.255.808.167.243.406.441.691.572v2.088c0 .412.185.808.513 1.1.328.29.773.455 1.238.455.464 0 .91-.164 1.237-.456.329-.291.513-.687.513-1.099v-1.914h3.033c.464 0 .91-.164 1.238-.455.328-.292.513-.687.513-1.1 0-.412-.185-.807-.513-1.098a1.869 1.869 0 0 0-1.238-.456Z" />
    </svg>
  );
};
export default IconFreshclub;
